import { IconProps } from "../../../types/style";

const BoxChecked = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 22 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.17017 6.93994L11.0002 12.0499L19.7701 6.96991"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.0002 21.11V12.04"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20.6101 8.67V14.33C20.6101 14.38 20.6101 14.42 20.6001 14.47C19.9001 13.86 19.0001 13.5 18.0001 13.5C17.0601 13.5 16.1901 13.83 15.5001 14.38C14.5801 15.11 14.0001 16.24 14.0001 17.5C14.0001 18.25 14.2101 18.96 14.5801 19.56C14.6701 19.72 14.7801 19.87 14.9001 20.01L13.0701 21.02C11.9301 21.66 10.0701 21.66 8.93011 21.02L3.59012 18.06C2.38012 17.39 1.39014 15.71 1.39014 14.33V8.67C1.39014 7.29 2.38012 5.61002 3.59012 4.94002L8.93011 1.98C10.0701 1.34 11.9301 1.34 13.0701 1.98L18.4101 4.94002C19.6201 5.61002 20.6101 7.29 20.6101 8.67Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export default BoxChecked;
